import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import NewInquiry from "../../components/NewInquiry";
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
export default function CreatePost(){

    
    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
   

    useEffect(() => {
        fetchPosts();
        console.log(posts)
    }, [skip,query]);
    const [openNewInquiry,setOpenNewInquiry] = useState(false)
    async function newInquiry(e){
        setOpenNewInquiry(true)
    }

    const closeInquiryNew = () => {
        setOpenNewInquiry(false)
    }
    const pickInquiry = (post) =>{
        history("/proformainvoice",{state:{stuff:"new",InquiryPhoneNumber:post.Phone, Inquiry:post}})
    }
    async function editInquiry(post){
        history("/edit-inquiry",{state:{stuff:"new", post}})
    }

    

    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis);
                    if(error){
                        
                        console.log(error.message);
                        return;
                    }
                    console.log(data.data)

                    if(data.data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }


                    const yoyo = data.data

                    //success
                    setPosts([...posts, ...yoyo])
                }catch(error){
                    console.log(error);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,query);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }

            
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }

    const [fileURL, setFileURL] = useState("");


    const previewPDF = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setLoadVisibility(true)
        const id = post._id
    
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`,{
           id 
        }, {
            responseType: "blob"
          }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setLoadVisibility(false)
                    setFileURL(fileURLNew)
                })
                

            

        
        
        console.log("2")
    
    }

    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value, searchThis);
            if(error){
                console.log(error.message);
                return;
            }

            if(data.data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            const yoyo = data.data
            //success
            setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,event.target.value);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }
    const ColorButton = styled(Button)(({ theme }) => ({
        color: theme.palette.getContrastText(purple[500]),
        backgroundColor: purple[500],
        '&:hover': {
          backgroundColor: purple[700],
        },
      }));

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }
    const [searchThis, setsearchThis]= useState("Phone");
    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }

    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const history = useNavigate();

    const editPI = async (post) => {
        if(currPreview === "none"){
            history("/create-kontrak",{state:{data:post, stuff:"edit"}})
        }else{
            history("/create-kontrak",{state:{data:currPreview, stuff:"edit"}})
        }
    }

    const extend = async (post)=>{
        if(currPreview === "none"){
            history("/create-kontrak", {state:{data:post,stuff:"extend"}})
        }else{
            history("/create-kontrak", {state:{data:currPreview,stuff:"extend"}})
        }
    }

    const [openSignature,setOpenSignature] = useState(false);
    const closeOpenSignature = () => {
        setOpenSignature(false)
    }

    const openSignatureNow = () => {
        setOpenSignature(true)

    }

    return <Grid container>
                <Dialog open={openNewInquiry} onClose={closeInquiryNew}>
                    <NewInquiry></NewInquiry>
                </Dialog>
                <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Grid>
                <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <iframe src={fileURL} width="100%" height="500" style={{zoom:"150%"}}/>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button variant="contained" color="error" style={{ marginRight: 'auto' }}>
                        Batal Kontrak
                    </Button>
                    <Button onClick={() => editPI()}>
                        <EditIcon></EditIcon>
                    </Button>
                    <ColorButton variant="contained" onClick={openSignatureNow}>Upload Tanda Tangan</ColorButton>
                    <Button onClick={() => extend()} variant="contained" color="success">
                        Extend
                    </Button>
                    </DialogActions>
                </Dialog>
                    <Grid></Grid>
                    <Grid>
                        <Grid item>
                            <Select  fullWidth value={searchThis} onChange={event => setsearchThis(event.target.value)}><MenuItem value="Phone">Nomor Telepon</MenuItem><MenuItem value="Nama">Nama Klien</MenuItem></Select>
                        </Grid>
                            <Grid>
                                <Button onClick={event => newInquiry()}>Create +</Button>
                                <TextField value={query} onChange={event => handleSearch(event)}></TextField>
                            </Grid>
                            <Grid container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 300, minHeight: 240 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    Nomor Telepon
                                                </TableCell>
                                                <TableCell>
                                                    Nama
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover onClick={()=> pickInquiry(post)}>
                                                    <TableCell onClick={()=> pickInquiry(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.Phone}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> pickInquiry(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.Nama}</p>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>
                            
                            
                    </Grid>
                </Grid>    
            </Grid>
    };